module.exports = __webpack_public_path__ + "media/images/icons/uzemniPlanovaniW-059af3f2cf25fb0f735cc43e75e771f7.svg";